module.exports = __webpack_public_path__ + "img/button.fd9fcd9c.svg";